<template>
  <a-card v-if="getScreen">
    <span slot="title">Credit Card Claim Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Usage" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps" :disabled="disabledActionBtnSts"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next" :disabled="disabledActionBtnSts">Next</a-button>
        <a-button
          v-if="current == steps.length - 1"
          type="default"
          :loading="btnLoading"
          @click="validate"
          :disabled="dataList.length < 1 || disabledActionBtnSts"
        >{{ status === false ? "Save Draft" : "Save" }}</a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :span="leftcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex flex-column nowrap">
        <span slot="title">Credit Card Claim Form</span>
        <a-steps :current="current" status="process">
          <a-step title="Information" />
          <a-step title="Usage" />
          <a-step title="Approval" />
        </a-steps>
        <div class="steps-content flex-1">
          <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button-group>
              <a-button v-if="current == 1" type="primary" @click="handleNew" :loading="loadingAdd" :disabled="disabledActionBtnSts">Add</a-button>
            <a-button v-if="current < steps.length - 1" type="default" @click="next" :disabled="disabledActionBtnSts">Next</a-button>
            <a-button
              v-if="type !== 'revised' && current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasiDraft"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save Draft</a-button>
            <a-button
              v-if="current == (steps.length - 1)"
              type="primary"
              :loading="btnLoading"
              @click="validasi"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save</a-button>
            </a-button-group>
            <a-button v-if="current > 0" @click="prev" :disabled="disabledActionBtnSts">Previous</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <a-col :span="rightcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex flex-column">
        <div slot="title">
          <span>Reporting Details</span>
        </div>
        <template slot="extra">
          <a-button @click="onCollective" class="margin-right-small" icon="edit">Collective</a-button>
          <a-button
            @click="handleExpand()"
            :icon="labelExpand == 'Expand' ? 'arrows-alt' : 'shrink'"
          >{{labelExpand}}</a-button>
        </template>
        <a-table
          :columns="columns"
          :dataSource="getCountWeb"
          :pagination="pagination"
          size="small"
          :scroll="{ x: 750 }"
          :loading="loadingtable"
          bordered
        >
          <template slot="description" slot-scope="text, item">
            <span>{{item.deskripsi}}</span>
              <br />
              <span>END USER : {{item.end_user_nm}}</span>
          </template>
          <template slot="commission" slot-scope="index, item">
              <span v-if="item.iscommision=='1'">
                Yes
              </span>
              <span v-else>
                No
              </span>
            </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="item_anggaran" slot-scope="text, item">
            <a-alert
              type="error"
              banner
              v-if="item.kredit!='' &&(item.item_anggaran == null || item.item_anggaran == '')"
              message="item anggaran cannot be empty"
            ></a-alert>
            <template v-else>
              <span>{{item.item_anggaran}}</span>
              <br />
              <span>{{item.kode_anggaran}}</span>
              <!-- <div v-if="item.jenis_activity">
                <br/>
                <b>Activity Type :</b> {{ item.jenis_activity }}
              </div>
              <div v-if="item.pipeline_no">
                <b>Pipeline :</b> {{ item.pipeline_no ? (item.pipeline_no+" | "+item.definitions) : '-' }}
              </div>
              <div v-if="item.activity">
                <b>Activity :</b> {{ item.activity ? item.activity : '-' }}
              </div> -->
            </template>
          </template>
          <template slot="prospect" slot-scope="item">
            <b>{{ item.no_prospek ? item.no_prospek : '-' }}</b> <br/> {{ item.description }}
          </template>
          <template slot="operation" slot-scope="index, item">
            <a-button-group v-if="item.kredit">
              <a-button type="primary" @click="handleEdit(item)" :loading="loadingEdit">
                <a-icon type="edit" />
              </a-button>
              <a-button type="danger" @click="handleRemoveDetail(item)">
                <a-icon type="close" />
              </a-button>
            </a-button-group>
          </template>

          <template slot="footer">
            <!-- <a-row type="flex" v-if="picForColumn === getAuth.username">
              <a-col :span="7" :order="1" class="m-text-align left">Total Debit</a-col>
              <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                <CurrencyJustified v-if="debit" currencyValue="IDR" :valueNumber="debit" />
              </a-col>
              <a-col :span="3" :order="3" class="m-text-align left m-text-bold"></a-col>
            </a-row> -->
            <a-row type="flex">
              <a-col :span="7" :order="1" class="m-text-align left">Total Credit</a-col>
              <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                <CurrencyJustified v-if="kredit" currencyValue="IDR" :valueNumber="kredit" />
              </a-col>
              <a-col :span="3" :order="3" class="m-text-align left m-text-bold"></a-col>
            </a-row>
            <!-- <a-row type="flex" v-if="picForColumn === getAuth.username">
              <a-col :span="7" :order="1" class="m-text-align left">Remaining Balance</a-col>
              <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                <CurrencyJustified
                  v-if="getRemainingBalance"
                  currencyValue="IDR"
                  :valueNumber="getRemainingBalance"
                />
              </a-col>
              <a-col :span="3" :order="3" class="m-text-align left m-text-bold"></a-col>
            </a-row> -->
          </template>
        </a-table>
        <template class="ant-card-actions" slot="actions">
          <div
            class="steps-action"
            v-if="
              current == steps.length - 1 ||
              (mode === 'Edit' && type !== 'draft')
            "
          >
            <a-button
              v-if="current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasi"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save</a-button>
            <a-button
              v-if="type !== 'revised' && current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasiDraft"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save Draft</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <Modal
      v-if="modal.modalEdit"
      :dataList="dataList"
      :data="modal.data"
      :modalEdit="modal.modalEdit"
      :confirmLoading="modal.confirmLoading"
      :getCostCenter="getCostCenter"
      :getPeruntukan="getPeruntukan"
      :getSubPeruntukan="getSubPeruntukan"
      :getAnggaran="getAnggaran"
    />

    <!-- Modal Collective -->
    <Collective v-if="isCollective" :close="handleCloseCollective">
      <div slot="title">
        <a-icon type="edit" />&nbsp;Edit Collective
      </div>
      <template slot="content">
        <loading v-if="anggaran.loadingtree" />
        <a-form class="margin-bottom" :form="formCollective">
          <a-row :gutter="24">
            <a-col span="12">
              <a-form-item label="Jenis Anggaran">
                <a-select
                  showSearch
                  :not-found-content="null"
                  option-filter-prop="children"
                  v-decorator="['jenis_anggaran', { rules: [{ required: true }]}]"
                  @change="handleJenisAnggaran"
                  disabled
                >
                  <a-select-option v-for="item in getJenisAnggaran" :key="item.value">{{item.text}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Cost Center">
                <a-select
                  disabled
                  showSearch
                  v-decorator="['cost_center', { rules: [{ required: true }]}]"
                  @change="handleCost"
                  ref="mcostCntr"
                >
                  <a-select-option
                    v-for="item in costCenter"
                    :key="item.value"
                  >{{item.text}} ({{item.nama_pekerjaan ? item.nama_pekerjaan : '-'}})</a-select-option>
                </a-select>
              </a-form-item>
              <a-row :gutter="24">
                <a-col span="9">
                  <a-form-item label="Activity Type" v-if="1==0 && $refs.mcostCntr && $refs.mcostCntr.value && $refs.mcostCntr.value.includes('MARDEV')">
                    <a-select placeholder="Please Select" 
                    ref="mrefactivity_type"
                    v-decorator="[
                      'activity_type',
                      { rules: [{ required: true }], initialValue:collectData.informasi.type_activity },
                    ]"
                    disabled
                    @change="changeActivity_type" class="width-full">
                      <a-select-option v-for="item in getMARDEVActivity.type" :key="item">
                        {{item}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="15">
                  <a-form-item label="Activity" v-if="1==0 && $refs.mcostCntr && $refs.mcostCntr.value && $refs.mcostCntr.value.includes('MARDEV') && $refs.mrefactivity_type && $refs.mrefactivity_type.value!='Project Penetration'">
                    <a-select placeholder="Please Select" 
                    v-decorator="[
                      'activity',
                      { rules: [{ required: true }], initialValue:collectData.informasi.activity },
                    ]" disabled class="width-full">
                      <a-select-option v-for="item in getMARDEVActivity.activity" :key="item">
                        {{item}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Pipeline" v-if="1==0 && $refs.mcostCntr && $refs.mcostCntr.value && $refs.mcostCntr.value.includes('MARDEV') && $refs.mrefactivity_type && $refs.mrefactivity_type.value=='Project Penetration'">
                    <a-select
                      showSearch
                      :not-found-content="null"
                      option-filter-prop="children"
                      v-decorator="[
                        'pipeline_id',
                        {
                          rules: [{ required: true }],
                          initialValue:collectData.informasi.pipeline_id
                        },
                      ]"
                      disabled
                    >
                      <a-select-option v-for="item in pipelineList" :key="item.pipeline_id">
                        [{{ item.pipeline_no}}] {{ item.definitions }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col span="12">
              <a-form-item label="Peruntukan">
                <a-select
                  disabled
                  showSearch
                  v-decorator="['peruntukan', { rules: [{ required: true }]}]"
                  @change="handlePeruntukan"
                  optionFilterProp="children"
                  :filterOption="filterOption"
                >
                  <a-select-option v-for="item in peruntukan" :key="item.value">{{ item.text }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Kode Anggaran">
                <a-tree-select
                  v-decorator="['kode_anggaran', {rules: [{required: true}]}]"
                  show-search
                  style="width: 100%"
                  @select="handlechoiceCost"
                  :dropdown-style="{ maxWidth: '200px', maxHeight: '400px' }"
                  :tree-data="anggaran.tree"
                  treeNodeFilterProp="children"
                  :filterTreeNode="filterTreeNode"
                  placeholder="Please select"
                  allow-clear
                  :treeExpandedKeys="treeExpandedKeys"
                  :disabled="anggaran.loadingtree || anggaran.tree==undefined || anggaran.tree.length==0"
                >
                  <div slot="title" slot-scope="item">
                    <div class="tree-between">
                      <div class="m-text-dots">
                        <span>{{item.texttitle}}</span>
                        <small>( {{item.kode_anggaran}} )</small>
                      </div>
                      <span>{{formatRupiah(parseFloat(item.rekap))}}</span>
                    </div>
                  </div>
                </a-tree-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 6 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-table
          :columns="columns"
          :dataSource="getCountWeb"
          :pagination="pagination"
          size="small"
          :scroll="{ x: 750 }"
          :loading="loadingtable"
          bordered
        >
        <template slot="customTitle">
            {{this.isCollective ? "Check" : "Action"}}&nbsp;
            <a-checkbox v-model="checkAllCollective" @change="onCheckAllChange">
            </a-checkbox>
          </template>
          <template slot="description" slot-scope="text, item">
            <span>{{item.deskripsi}}</span>
              <br />
              <span>end user : {{item.end_user_nm}}</span>
          </template>
          <template slot="commission" slot-scope="index, item">
              <span v-if="item.iscommision=='1'">
                Yes
              </span>
              <span v-else>
                No
              </span>
            </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          <template slot="item_anggaran" slot-scope="text, item">
            <a-alert
              type="error"
              banner
              v-if="item.kredit!='' &&(item.item_anggaran == null || item.item_anggaran == '')"
              message="item anggaran cannot be empty"
            ></a-alert>
            <template v-else>
              <span>{{item.item_anggaran}}</span>
              <br />
              <span>{{item.kode_anggaran}}</span>
              <!-- <div v-if="item.jenis_activity">
                <br/>
                <b>Activity Type :</b> {{ item.jenis_activity }}
              </div>
              <div v-if="item.pipeline_no">
                <b>Pipeline :</b> {{ item.pipeline_no ? (item.pipeline_no+" | "+item.definitions) : '-' }}
              </div>
              <div v-if="item.activity">
                <b>Activity :</b> {{ item.activity ? item.activity : '-' }}
              </div> -->
            </template>
          </template>
          <template slot="prospect" slot-scope="item">
            <b>{{ item.no_prospek ? item.no_prospek : '-' }}</b> <br/> {{ item.description }}
          </template>
          <template slot="operation" slot-scope="index, item">
            <a-checkbox
              :checked="selectedTree.filter(obj => obj.id == item.id).length == 0 ? false : true"
              @change="handleCheck"
              :value="item"
            ></a-checkbox>
          </template>
        </a-table>
      </template>
      <a-button-group slot="action">
        <a-button @click="handleSet" type="primary" :disabled="selectedTree.length == 0"
        :loading="setloading"
        >Set</a-button>
        <a-button
          @click="handleCloseCollective"
          :type="selectedTree.length == 0 ? 'primary' : ''"
        >Done</a-button>
      </a-button-group>
    </Collective>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Informasi from "./steps/Informasi.vue";
import Pemakaian from "./steps/Pemakaian.vue";
import Approval from "./steps/Persetujuan.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import CollectiveKlaimCC from "@/mixins/collective/collectiveKlaimCC";
import nanoid from "nanoid";
import Modal from "./Modal.vue";
import moment from "moment";
import Collective from "../../components/collective/Collective.vue";
import Loading from "@/components/preloader/Loading.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "CreateKlaimCreditCard",
  props: ["id", "type"],
  components: {
    Informasi,
    Pemakaian,
    Approval,
    Modal,
    Collective,
    Loading,
  },
  mixins: [CurrencyFormat, CollectiveKlaimCC, GlobalMethod],
  data() {
    return {
      loading: true,
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Pemakaian",
          content: "Pemakaian",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData: {},
      mode: "Create",
      id_klaim: "",
      active: false,
      status: false,
      dataList: [],
      url: "",
      debit: 0,
      kredit: 0,
      mata_uang: "",
      sisa_saldo: 0,
      pageLoading: true,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      btnLoading: false,
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          alokasi: "",
          proyek: "",
        },
      },
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingtable: false,
      isCollective: false,
      loadingAdd: false,
      loadingEdit: false,
      EnCommission: false,
      Viwithout_note: true,
      checkAllCollective: false,
      setloading: false,
      disabledActionBtnSts: false,
    };
  },
  created() {
    this.$store.dispatch("FETCH_COST_CENTER");
    this.id_klaim = nanoid(11);
    this.fetch();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
      "getJenisAnggaran",
      "getBodDirektur",
      "getMARDEVActivity",
    ]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            dataList: this.dataList,
            others: this.collectData.others,
            mode: this.mode,
            type: this.type,
            active: this.active,
            id_klaim: this.id_klaim,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          return {
            data: this.collectData.pemakaian,
            informasi: this.collectData.informasi,
            id_klaim: this.collectData.others.id_klaim
              ? this.collectData.others.id_klaim
              : this.id,
            mode: this.mode,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            url: this.url,
            type: this.type,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            others: this.collectData.others,
            dataList: this.dataList,
            mode: this.mode,
            type: this.type,
            active: this.active,
            id_klaim: this.id,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          if (this.type === "draft") {
            return {
              data: this.collectData.pemakaian,
              informasi: this.collectData.informasi,
              id_klaim: this.id,
              mode: this.mode,
              dataList: this.dataList,
              debit: this.debit,
              kredit: this.kredit,
              mata_uang: this.mata_uang,
              url: this.url,
            };
          } else {
            return {
              data: this.collectData.pemakaian,
              informasi: this.collectData.informasi,
              id_klaim: this.id_klaim,
              mode: this.mode,
              dataList: this.dataList,
              debit: this.debit,
              kredit: this.kredit,
              mata_uang: this.mata_uang,
              url: this.url,
            };
          }
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      }
      return true;
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Pemakaian") {
        return "refPemakaian";
      } else{
        return "refApproval";
      }
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          align: "center",
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Date",
          dataIndex: "tanggal",
          width: 110,
          key: "tanggal",
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Description",
          //dataIndex: "deskripsi",
          key: "deskripsi",
          width: 200,
          scopedSlots: { customRender: "description" },
          sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
        {
          title: "Commission",
          key: "commission",
          scopedSlots: { customRender: "commission" },
          width: 125,
          align: "center"
        },
        {
          title: "Item Anggaran",
          key: "item_anggaran",
          width: 250,
          scopedSlots: { customRender: "item_anggaran" },
          sorter: (a, b) => a.item_anggaran.length - b.item_anggaran.length,
        },
        {
          title: "Prospect",
          key: "prospect",
          width: 250,
          scopedSlots: { customRender: "prospect" },
          sorter: (a, b) => a.no_prospek - b.no_prospek,
        },
        {
          title: "Credit",
          dataIndex: "kredit_value",
          key: "kredit_value",
          align: "right",
          width: 170,
          sorter: (a, b) => a.kredit.length - b.kredit.length,
        },
        {
          slots: { title: 'customTitle' },
          // this.isCollective ? "Check" : "Action",
          scopedSlots: { customRender: "operation" },
          width: this.isCollective ? 90 : 110,
          align: "center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.dataList;
      let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          data[index]["no"] = index + 1;
          data[index]["key"] = index;

          if (value.kredit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.kredit
            );
            debit -= value.kredit;
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);

            data[index]["sisa_value"] = debit;
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
        });
      }
      return data;
    },
    getRemainingBalance() {
      return this.dataList !== undefined
        ? this.dataList.length > 0
          ? this.dataList[this.dataList.length - 1].sisa_value
          : 0
        : 0;
    },
    disableSaveButton() {
      let result = this.labelExpand == "Collapse";
      if (result) {
        result = true;
      } else {
        result = this.dataList.length < 1;
      }
      return result;
    },
  },
  methods: {
    moment,
    ...mapActions(["FETCH_ALLOCATION", "FETCH_USEDFOR"]),
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Pemakaian") {
        if(this.dataList.length<=0){
            this.displayMessageValue(
              "error-other",
              "Data Details can't be empty, because this transaction has at least 1 data!"
            );
        }else{
          let exceedDate = _.filter(this.dataList, item => moment(item.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD'))
          if(exceedDate.length>0){
            this.displayMessageValue("error-other", "Expense date can't exceed today!");
            return;
          }
          this.getApproval();
        }
      }
    },
    prev() {
      if(this.steps[this.current].content === "Approval"){
        this.$refs.refApproval.handleRef();
        this.expandcolumn("collapse");
      }
      this.current--;
    },
    validasi() {
      if (!this.getScreen) {
        this.status = true;
      }
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    validasiDraft() {
      this.confirmMessage("confirm-draft");
    },
    validate() {
      this.$refs.refApproval.handleRef();
      this.btnLoading = true;
      // console.log(this.status);
      if (this.status) {
        let postData;
        let method;
        let contentType;
        let link;
        if (this.type === "revised") {
          method = "put";
          contentType = "application/json";
          link = "/pu/klaimmanifestcc/" + this.collectData.others.id_klaim;
          postData = {
            tlc: this.getAuth.username,
            id_klaim: this.id,
            approval_pic: this.collectData.informasi.pic,
            tlc_direktur: this.collectData.informasi.bod,
            tanggal_pelaporan:
              this.collectData.informasi.tanggal_pelaporan.format("YYYY-MM-DD"),
            public_manifest_url: link,
            catatan: this.collectData.informasi.catatan ?
              this.collectData.informasi.catatan : '',
          };
        } else {
          method = "post";
          contentType = "multipart/form-data";
          postData = new FormData();
          link = "/pu/klaimmanifestcc/" + this.id_klaim;

          if (this.mode === "Edit") {
            postData.append("id_klaim", this.collectData.others.id_klaim);
          } else {
            postData.append("id_klaim", this.id_klaim);
          }
          postData.append("tlc", this.getAuth.username);
          postData.append("tlc_direktur", this.collectData.informasi.bod);
          postData.append(
            "tanggal_pelaporan",
            this.collectData.informasi.tanggal_pelaporan.format("YYYY-MM-DD")
          );
          postData.append("public_manifest_url", link);
          postData.append("catatan", this.collectData.informasi.catatan ?
            this.collectData.informasi.catatan : '');
        }
        axios({
          method: method,
          url: this.$serviceUrl + "klaim_cc",
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": contentType,
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-save");
            this.btnLoading = false;
            if(this.$route.path.includes("/keuangan/")){
              this.$router.push({ name: "klaimCCKeu" });
            }else{
              this.$router.push({ name: "klaimCC" });
            }
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (
              response.data.message.includes("Tidak Memiliki Detil Pemakaian")
            ) {
              this.displayMessageValue(
                "error-notif-kaskecil",
                response.data.message
              );
            } else {
              let responses = Object.assign({}, err.response);
              if (responses.data) {
                this.displayMessageValue("error-other", responses.data.message);
              } else {
                this.displayMessageValue("error", responses);
              }
            }
            this.btnLoading = false;
          });
      } else {
        this.savecatatan();
      }
    },
    savecatatan(){
      axios({
          method: "post",
          url: this.$serviceUrl + "klaim_cc/draft",
          data: {
            id_klaim : this.id ? this.id : this.id_klaim,
            catatan: this.collectData.informasi.catatan
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.displayMessage("success-edit");
            if(this.$route.path.includes("/keuangan/")){
              this.$router.push({ name: "klaimCCKeu" });
            }else{
              this.$router.push({ name: "klaimCC" });
            }
          })
          .catch((response) => {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error-other",responses);
          });
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value;
        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        // this.collectData.persetujuan = JSON.parse(
        //   JSON.stringify(value.persetujuan)
        // );
        // if (this.mode === "Edit") {
        //   this.confirmMessage("confirm-edit");
        // } else {
        //   this.confirmMessage("confirm-save");
        // }
        this.current++;
      } else if (this.steps[this.current].content === "Approval"){
        this.collectData.informasi.catatan = value.note;
      }
    },
    controlForm(value) {
      this.active = value;
    },
    draftStatus(val) {
      this.status = val;
    },
    async fetchEdit(url) {
      return await new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: url,
          params: {
            id_klaim: this.id,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.collectData = {
              informasi: {
                tanggal_pelaporan: response.data.tgl_buat,
                catatan: response.data.catatan,
                jenis_anggaran: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].jns_anggaran_id : null,
                cost_center: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].cost_center_id : null,
                peruntukan: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].peruntukan_id : null,
                activity: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].activity : null,
                type_activity: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].jenis_activity : null,
                pipeline_id: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].pipeline_id: null,
                id_user_cc: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].id_user_cc: null,
              },
              others: {
                mata_uang: response.data.mata_uang,
                id_klaim: response.data.id_klaim_cc,
                total_kredit: response.data.total_kredit,
              },
            };
            this.dataList = response.data.detail_pemakaian
              ? response.data.detail_pemakaian
              : new Array();
            this.loading = false;
            resolve(response);
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
            reject(err);
          });
      });
    },
    searchBod(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: url,
          params: {
            id_klaim: this.id,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            let informasi = {
              tanggal_pelaporan: (this.collectData.informasi ? this.collectData.informasi.tanggal_pelaporan : null),
              bod: response.data.tlc_bod,
            };
            this.collectData.informasi = informasi;
            resolve(response);
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
            reject(err);
          });
      });
    },
    fetchPemakaian() {
      let id_klaim;
      this.loadingAdd = true;
      if (this.type === "revised" || this.type === "draft") {
        id_klaim = this.id;
      } else {
        id_klaim = this.id_klaim;
      }

      if (!this.getScreen) {
        axios({
          method: "get",
          url: this.url,
          params: {
            tlc: this.getAuth.username,
            id_klaim: id_klaim,
            mode: this.mode,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataList = response.data.detail_pemakaian
              ? response.data.detail_pemakaian
              : new Array();
            this.kredit = response.data.total_kredit;
            this.debit = response.data.total_debit;
            this.mata_uang = response.data.mata_uang;
            if (this.dataList.length === 1) {
              this.active = false;
            }

            this.$refs.refPemakaian.done();
            this.loadingAdd = false;
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (response.message === "Tidak Memiliki Detil Pemakaian") {
              this.active = false;
              this.mode = "Create";
              this.dataList = [];
              this.debit = 0;
              this.kredit = 0;

              if (this.type === "draft") {
                this.$router.go(-1);
              }

              this.$refs.refPemakaian.done();

              if (this.mode !== "Create") {
                this.displayMessageValue(
                  "error-notif-kaskecil",
                  response.message
                );
              }
            }
            this.loadingAdd = false;
            this.loading = false;
          });
      } else {
        if (this.steps[this.current].content === "Pemakaian") {
          axios({
            method: "get",
            url: this.url,
            params: {
              tlc: this.getAuth.username,
              id_klaim: id_klaim,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.dataList = response.data.detail_pemakaian
                ? response.data.detail_pemakaian
                : new Array();
              this.kredit = response.data.total_kredit;
              this.debit = response.data.total_debit;
              this.mata_uang = response.data.mata_uang;
              this.$refs.refPemakaian.done();
              if (this.dataList.length === 1) {
                this.active = false;
              }
              this.loadingAdd = false;
            })
            .catch((err) => {
              if (
                err.response.data.message === "Tidak Memiliki Detil Pemakaian"
              ) {
                this.active = false;
                this.$refs.refPemakaian.done();
              } 
              this.loading = false;
              this.loadingAdd = false;
            });
        }
      }
    },
    handleCheckData(e) {
      this.draftStatus(e.target.checked);
    },
    handleNew() {
      this.$refs.refPemakaian.handleNew();
    },
    handleEdit(item) {
      let angcode =
        item.peruntukan_id +
        ";" +
        item.sub_peruntukan_id +
        ";" +
        item.kode_anggaran_id;

      this.modal.data = {
        path: item.path,
        anggaran_code: angcode == "null;null;null" ? undefined : angcode,
        tanggal_pemakaian: item.tanggal_pemakaian,
        deskripsi: item.deskripsi,
        kredit: item.kredit,
        id: item.id,
        id_klaim: this.id_klaim,
        type: this.type,
        alokasi: item.alokasi,
        cost_center_id: item.cost_center_id,
        peruntukan_id: item.peruntukan_id,
        sub_peruntukan_id: item.sub_peruntukan_id,
        kode_anggaran_id: item.kode_anggaran_id,
        jns_anggaran_id: item.jns_anggaran_id,
        end_user: item.id_user_cc,
        iscommision: item.iscommision ? item.iscommision : "0",
        without_note: item.without_note ? item.without_note : "1",
        pipeline_id: item.pipeline_id ? item.pipeline_id : null,
        activity: item.activity ? item.activity : null,
        activity_type: item.jenis_activity ? item.jenis_activity : null,
        prospek: item.prospek
      };

      if (!item.iscommision){
        // this.modal.data.EnCommission=true;
        this.modal.data.Viwithout_note=true;
      }else if(item.iscommision=="1" && item.is_komisi_ori){
        // this.modal.data.EnCommission=true;
        this.modal.data.Viwithout_note=false;
      }else if(item.iscommision=="1" && !item.is_komisi_ori){
        // this.modal.data.EnCommission=false;
        this.modal.data.Viwithout_note=false;
      }else{
        this.modal.data.iscommision=="0";
        // this.modal.data.EnCommission=false;
        this.modal.data.Viwithout_note=true;
      }

      if(item.prospek){
        this.modal.data['prospek'] = item.prospek
      }

      if (item.lampiran) {
        this.loadingEdit = true;
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(item.lampiran);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            item.lampiran
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + item.lampiran_path;
          this.modal.data.doctransfiles = [];
          this.modal.data.doctransfiles.push(file);

          this.modal.modalEdit = true;
          this.loadingEdit = false;
          this.modal.type = this.type;
        })
          .catch((err) => {
          this.loadingEdit = false;
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      } else {
        this.modal.modalEdit = true;
        this.modal.type = this.type;
      }
    },
    handleCancel(e) {
      this.modal.modalEdit = false;
      if (this.$refs.refPemakaian) {
        // this.$refs.refPemakaian.recountingAnggaran(this.dataList);
        this.$refs.refPemakaian.getTreeAnggaran();
      }
    },
    handleRemoveDetail(item) {
      if (this.dataList.length > 2) {
        this.confirmMessageValue("confirm-delete", item);
      } 
      // else if (this.mode == "Edit" && this.dataList.length == 1) {      
      //   this.displayMessageValue(
      //     "error-other",
      //     "can not delete this data, because this transaction has at least 1 data!"
      //   );
      // } 
      else {
        if (this.type === "draft") {
          this.confirmMessageValue("confirm-delete", item);
        } else {
          this.confirmMessageValue("confirm-delete-clear", item);
        }
      }
    },
    deleteClear(item) {
      this.delete(item);
    },
    delete(item) {
      const serviceUrl = this.$serviceUrl;
      let url =
        this.type === "revised"
          ? "klaim_cc/revisi_klaim_cc_dtl"
          : "klaim_cc/klaim_cc_dtl_draft";
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      this.loadingtable = true;
      axios({
        method: "delete",
        url: serviceUrl + url,
        processData: false,
        data: {
          id: item.id,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          if (
            response.data.message === "Berhasil Delete Detil Pemakaian" &&
            this.dataList.length == 2
          ) {
            if(this.$route.path.includes("/keuangan/")){
              this.$router.push({ name: "klaimCCKeu" });
            }else{
              this.$router.push({ name: "klaimCC" });
            }
          } else {
            if (this.$refs.refPemakaian) {
              this.$refs.refPemakaian.resetFormPemakaian(false);
            }
            Event.$emit("fetchPemakaian", 0);
          }
          this.loadingtable = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingtable = false;
        });
    },
    switchMode(value) {
      this.mode = value;
    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        this.pagination.pageSize = 5;
      }
    },
    fetch() {
      if (this.id) {
        this.mode = "Edit";
        if (this.type === "draft") {
          this.url =
            this.$serviceUrl + "klaim_cc/klaim_cc_dtl_draft";
          this.fetchEdit(this.url);
        } else {
          this.url =
            this.$serviceUrl + "klaim_cc/revisi_klaim_cc_dtl";
          let bodLink = this.$serviceUrl + "klaim_cc/bod_pic";
          this.fetchEdit(this.url);
          // this.searchBod(bodLink);
        }
      } else if (this.mode === "Create") {
        this.url = this.$serviceUrl + "klaim_cc/klaim_cc_dtl_draft";
        this.loading = false;
      }

      if (this.id && this.mode === "Edit" && !this.getScreen && this.loading) {
        this.fetchPemakaian();
      }
    },
    handleLoading(value) {
      this.loadingAdd = value;
    },
    back(){
      //this.$router.go(-1);
      this.$refs.refApproval.handleRef();
      this.savecatatan();
    },
    async getApproval(){
      let params = {
        tlc : this.getAuth.username,
        tlc_direktur : this.collectData.informasi.no_sppd,
        id_klaim : this.id ? this.id : null,
        is_draft: this.type=='revised' ? 0 : 1,
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "klaim_cc/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.expandcolumn("expand");
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    expandcolumn(val){
      if(val=="expand"){
          this.leftcolumn = 24;
          this.rightcolumn = 0;
      }else{
          this.leftcolumn = 12;
          this.rightcolumn = 12;
      }
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
          this.formCollective.setFieldsValue({
              without_note: "0",
          });
        });
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    onCheckAllChange(val){
      this.getCountWeb.forEach((element) => {
        if(element.edit_hapus!='0'){
          let index = _.findIndex(
            this.selectedTree,
            (e) => {
              return e.id == element.id;
            }
          );

          if(val.target.checked){
            if(index < 0){
              this.selectedTree.push(element)
            }
          }else{
            if(index >= 0){
              this.selectedTree = _.filter(this.selectedTree, (e) => e.id!=element.id)
            }
          }
        }
      })
    },
    triggerActionBtnKlaimCC(val){
      this.disabledActionBtnSts = val
    },
    changeActivity_type(val){
      if(val=="Non Project"){
        this.$nextTick(function () {
          this.formCollective.setFieldsValue({
            activity: null,
          });
        });
      }else{
        this.$nextTick(function () {
          this.formCollective.setFieldsValue({
              pipeline_id: null,
          });
        });
      }
    },
    async initialPipeline(e){
      await axios({
        method: "get",
        url: this.$serviceUrl + "klaim_direktur/pipeline",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.pipelineList = response.data.data?response.data.data:[]
      })
      .catch((err) => {
        let responses = Object.assign({}, err.response);
        this.displayMessageValue("error", responses);
      });
    },
  },
  mounted() {
    this.FETCH_ALLOCATION();
    this.FETCH_USEDFOR();
    Event.$on("kDirekturInformasi", this.valueFromChild);
    Event.$on("disableInformasi", this.controlForm);
    Event.$on("draftStatus", this.draftStatus);
    Event.$on("fetchPemakaian", this.fetchPemakaian);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("removeDetail", this.handleRemoveDetail);
    Event.$on("switchMode", this.switchMode);
    Event.$on("confirmMessageReturn", this.validate);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageDeleteClear", this.deleteClear);
    Event.$on("confirmDraftReturn", this.back)
    Event.$on("handleLoading", this.handleLoading);
    Event.$on("triggerActionBtnKlaimCC", this.triggerActionBtnKlaimCC);
  },
  beforeDestroy() {
    Event.$off("kDirekturInformasi", this.valueFromChild);
    Event.$off("disableInformasi", this.controlForm);
    Event.$off("draftStatus", this.draftStatus);
    Event.$off("fetchPemakaian", this.fetchPemakaian);
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("removeDetail", this.handleRemoveDetail);
    Event.$off("confirmMessageReturn", this.validate);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageDeleteClear", this.deleteClear);
    Event.$off("confirmDraftReturn", this.back)
    Event.$off("triggerActionBtnKlaimCC", this.triggerActionBtnKlaimCC);
  },
  watch: {
    "collectData.informasi.cost_center"(){
      if(this.collectData.informasi.cost_center)
        this.initialPipeline(this.collectData.informasi.cost_center)
    }
  }
};
</script>

<style lang="less" scoped>
.tree-between {
  display: flex;
  justify-content: space-between;
}
.m-text-dots {
  width: 60%;
}
</style>